import React from 'react';

export type Validators<T> = Partial<
  Record<keyof T, (value: any) => string | null>
>;

// The form API available to clients.
export interface FormApi<T> {
  formData: Partial<T>;
  formErrors: Partial<Record<keyof T, string>>;
  setFormData: (formData: Partial<T>) => void;
  validators: Validators<T>;
  // A field is registered that it exists under a form when the React component
  // is hydrated in the tree and unregistered when it is removed. This is used to
  // manage only validating fields that exist in the form.
  register: (field: keyof T) => void;
  unregister: (field: keyof T) => void;
}

// The form context used to provide the FormApi to components under the <Form />.
export const FormContext = React.createContext<FormApi<any>>(
  {} as FormApi<any>,
);
